/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import arrow from "../../../assets/img/landings/next_btn.svg";
import "./index.css";

export const AnimBtn = ({
  setIsFinished,
  setIsStarted,
  isStarted,
  isFinished,
}) => {
  const clickHandler = () => {
    isStarted ? setIsFinished(true) : setIsStarted(true);
  };

  if (isFinished) {
    return null;
  }

  return (
    <button className="animation-btn" onClick={clickHandler}>
      <span>{!isStarted ? "Scroll down" : "Skip"}</span>
      <img src={arrow} alt="Arrow" />
    </button>
  );
};
